// Generated with util/create-component.js
import React from "react";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";

import {
  MenuItem,
  MenuProps,
  MenuSection,
  MenuSubTitle,
  MenuDivider,
} from "./Menu.types";

import {
  StyledMenuContainer,
  StyledMenuItem,
  StyledMenuDivider,
  StyledMenuSubtitle,
} from "./Menu.styles";

const Container: React.FC<MenuProps> = ({ children, theme, variant }) => {
  return (
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <StyledMenuContainer theme={theme} data-testid="Menu" variant={variant}>
        {children}
      </StyledMenuContainer>
    </StyleSheetManager>
  );
};

const Item: React.FC<MenuItem> = ({ label, children, theme, variant, onClick }) => (
  <StyleSheetManager shouldForwardProp={isPropValid}>
    <StyledMenuItem theme={theme} data-testid="Menu-Item" variant={variant} onClick={onClick}>
      {label}
      {children && <div className="description">{children}</div>}
    </StyledMenuItem>
  </StyleSheetManager>
);

const Divider: React.FC<MenuDivider> = ({ theme, variant }) => (
  <StyleSheetManager shouldForwardProp={isPropValid}>
    <StyledMenuDivider theme={theme} data-testid="Menu-Divider" variant={variant}/> 
  </StyleSheetManager>
);

const SubTitle: React.FC<MenuSubTitle> = ({ label, theme, variant }) => (
  <StyleSheetManager shouldForwardProp={isPropValid}>
    <StyledMenuSubtitle theme={theme} data-testid="Menu-Subtitle" variant={variant}>
      {label}
    </StyledMenuSubtitle>
  </StyleSheetManager>
);

const Section: React.FC<MenuSection> = ({ label, children, theme, variant }) => {
  return (
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <SubTitle theme={theme} label={label} variant={variant}/>
      {children}
      <Divider theme={theme} />
    </StyleSheetManager>
  );
};

export default {
  Container,
  Item,
  Divider,
  SubTitle,
  Section,
};
